/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryChainOperand =
  GamoraFoundationAdapterQuery[];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryChainResult = unknown[];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryChainArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryChainOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryChain extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryChainOperand,
  GamoraFoundationAdapterQueryChainResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.CHAIN;
  constructor(args: GamoraFoundationAdapterQueryChainArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryChainOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryChain {
    return new GamoraFoundationAdapterQueryChain({
      operand,
      options,
    });
  }
}
